import React from 'react';
import { Checkbox, FormControlLabel, Typography, withStyles } from '@material-ui/core';
import useTranslateText from '../use_translate_text';

const _Checkbox = (props) => {

  const { disableForm, checked, handleChange, name, value, from } = props,
        { translateText } = useTranslateText(),
        OrangeCheckbox = withStyles({
          root: {
            color: 'white',
            height: '20px',
            width: '20px',
            border: '1px solid #CBD1D4',
            borderRadius: '10% 10% 10% 10%',
            cursor: 'pointer',
            marginLeft: 9,
            marginRight: 6,
            '&$disabled': {
              color: 'white',
            },
            '&$checked': {
              '& .MuiIconButton-label': {
                position: 'relative',
                zIndex: 0,
                color: 'white',
                height: '20px',
                width: '20px',
                border: '2px solid #CBD1D4',
                borderRadius: '10% 10% 10% 10%',
              },
              '& .MuiIconButton-label:after': {
                content: '""',
                top: from === 'mfa' && 2 || 1,
                height: from === 'mfa' && 12 || 14,
                width: 13,
                position: 'absolute',
                backgroundColor: '#EB9937',
                zIndex: -1,
              },
            },
          },
          checked: {},
          disabled: {},
        })((props) => <Checkbox color="secondry" {...props}></Checkbox>);

  return (
    <FormControlLabel
      disabled={disableForm || false}
      control={<OrangeCheckbox checked={checked} onChange={handleChange} name={name}
        value={value}
      />}
      label={
        <Typography variant="span" style={{ color: '#81A7BB' }}>
          {translateText(value)}
        </Typography>
      }
    />
  );
};

export default _Checkbox;
